import { atom } from "recoil"

export const Map = atom({
  key: "Map",
  default: 0,
})
